export default __webpack_public_path__ + "static/media/package-checked.6fb85e42.png";